/* Components */
import "@cheil-uk/support-components";
import $ from "jquery";
import Handlebars from "hbs";
import Utilites from "./components/utilities";
import Troubleshooters from "./components/troubleshooters";
//import TsInterpreter from './components/tsInterpreter'
//import ZoomRepairBooking from './components/zoomRepairBooking'

import ChatWindow from "./components/chatWindow";
//import RepairOptions from "./components/repairOptions";
//import RepairOptionsVideos from "./components/repairOptionsVideos";
import StickyWrapper from "./components/stickyWrapper";

/* Application State */
import State from "./state";

/* Initialise QuickWash */
$(document).ready(function () {
  /* Tiny PubSub - we should move this somewhere else */
  (function (n) {
    var u = n({});
    (n.subscribe = function () {
      u.on.apply(u, arguments);
    }),
      (n.unsubscribe = function () {
        u.off.apply(u, arguments);
      }),
      (n.publish = function () {
        u.trigger.apply(u, arguments);
      });
  })(jQuery);

  //** Run time helpers **/
  Handlebars.registerHelper("if_odd", function (conditional, options) {
    if (conditional % 2 == 1) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });

  /* Set application defaults */
  const application = (window.state = new State());

  /* Initialise components */
  const utilities = new Utilites();
 // const repairOptions = new RepairOptions();
 // const repairOptionsVideos = new RepairOptionsVideos();
 // repairOptionsVideos.init();

  const troubleshooters = new Troubleshooters();

  const stickyWrapper = new StickyWrapper();

  //const tsInterpreter = new TsInterpreter()
  //const zoomRepairBooking = new ZoomRepairBooking()
  //const zoomAndChatWindow = new ZoomAndChatWindow()


  log("initalised 🦄", { Info: project }, " 🚀 🚀 🚀 🚀 🚀 🚀 🚀");
});
